<template>
	<v-container fill-height fluid>
		<v-row>
			<v-col cols="6" class="pa-0">
				<AuthSidebar/>
			</v-col>
			<v-col cols="6" class="pa-0">
				<div class="right-section ">
					<v-row no-gutters>
						<v-col cols="10" class="text-right"></v-col>
						<v-col cols="2">
							<LanguageSelection class="float-right" />
						</v-col>
					</v-row>
					<div  v-if="registerType==null" class="flex-direction-box">
						<div class="login-from vertical-center">
							<h2>{{ $t("login.signUpWith") }}</h2>
							<p class="gray--text">{{ $t("login.registerOption") }}</p>
							<div class="mt-15 mb-10">
								<v-btn @click="$router.push({ name: 'Register', params: {type: 'email'}})" x-large depressed block color="primary" class="mt-5">{{ $t("login.email") }}</v-btn>
								<div class="mt-8 mb-8" style="width: 100%; height: 15px; border-bottom: 1px solid black; text-align: center">
									<span style="font-size: 20px; background-color: #F3F5F6; padding: 0 20px;">
										{{ $t('login.or') }} <!--Padding is optional-->
									</span>
								</div>
								<v-btn @click="$router.push({ name: 'Register', params: {type: 'mobile'}})" x-large outlined block color="primary" class="mt-5">{{ $t("login.phone") }}</v-btn>
							</div>
							{{$t('login.alreadyHaveAccount')}}?  <router-link style="text-decoration:none" class="forget primary--text" color="Primary" to="/login">{{ $t('login.loginNow') }}</router-link>
						</div>
					</div>
					<EmailRegister :registerType="registerType" v-if="registerType!=null"/>
					<!-- <MobileRegister v-if="registerType=='mobile'"/> -->
        		</div>
      		</v-col>
    	</v-row>
  	</v-container>
</template>

<script>
import loading from "@/mixins/LoadingMixin";
import generalMixin from "@/mixins/GeneralMixin";

import AuthSidebar from "./AuthSidebar.vue"
import EmailRegister from "./EmailRegister.vue";
// import MobileRegister from "./MobileRegister.vue";

  export default {
	mounted() {
		if(this.$route.params.type && (this.$route.params.type || this.$route.params.type == 'mobile')){
			this.registerType = this.$route.params.type;
		}
	},
	watch: {
		'$route.params.type': {
			handler: function(type) {
				this.registerType = type;
			},
			deep: true,
			immediate: true
		}
	},
	components: {
		AuthSidebar,
		EmailRegister,
		// MobileRegister
	},
	computed: {
		isAuthErr() {
			return this.authErr.length > 0;
		}
	},
    data() {
      return {
		error: false,
		registerType: null
      }
    },
    methods: {

    },
    mixins: [loading, generalMixin]
  };
</script>

<style scoped lang="scss">
.right-section {
	padding: 6px 20px;
	background-color: white;
	height: 100vh;
}
.vertical-center {
  margin: 0;
  position: absolute;
  top: 50%;
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
}

.right-section .login-from h2{
	font-size:30px;
	font-family: pop_semiBold;
	font-weight: 600;
	margin-bottom: 0px
}
.right-section .login-from p{
	color:#AABDCF;
	font-size: 12px;
	font-family: pop_regular;
	width: 508px;
	margin-top: 3px;
}
.flex-direction-box {
	height: 546px;
	max-height: 100%;
	display: flex;
	justify-content: center;
	align-items: center;
}

select:focus-visible {
	outline: none;
}

</style>
